import { useState } from "react";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import { CONTENT } from "@/content";
import { funnelState, type ContactData, type AnswersData } from "@/lib/funnelState";
import { P2 } from "@/components/funnel/P2";
import { P3 } from "@/components/funnel/P3";
import { P4 } from "@/components/funnel/P4";
import { P5 } from "@/components/funnel/P5";

export default function Funil() {
  const navigate = useNavigate();
  const [contact, setContactState] = useState<ContactData>({});
  const [answers, setAnswersState] = useState<AnswersData>({});

  const goHome = () => {
    funnelState.clear();
    navigate("/");
  };
  const openWhats = () =>
    window.open(CONTENT.brand.whatsappUrl, "_blank", "noopener");

  return (
    <Routes>
      <Route
        index
        element={<Navigate to="contato" replace />}
      />
      <Route
        path="contato"
        element={
          <P2
            data={contact}
            setData={setContactState}
            onNext={() => navigate("/agendar/historia")}
            onHome={goHome}
          />
        }
      />
      <Route
        path="historia"
        element={
          <RequireLead>
            <P3
              answers={answers}
              setAnswers={setAnswersState}
              onNext={() => navigate("/agendar/horario")}
              onHome={goHome}
            />
          </RequireLead>
        }
      />
      <Route
        path="horario"
        element={
          <RequireLead>
            <P4
              onConfirm={() => navigate("/agendar/obrigado")}
              onHome={goHome}
            />
          </RequireLead>
        }
      />
      <Route
        path="obrigado"
        element={<P5 onHome={goHome} onWhats={openWhats} />}
      />
      <Route path="*" element={<Navigate to="contato" replace />} />
    </Routes>
  );
}

function RequireLead({ children }: { children: React.ReactElement }) {
  if (!funnelState.getLeadId()) {
    return <Navigate to="/agendar/contato" replace />;
  }
  return children;
}
